import React from "react";
import { CompanyCardData } from "./types";

interface Props {
  entries: CompanyCardData["glossary"];
}

const Glossary: React.FC<Props> = ({ entries }) => (
  <div className="vi-glass-card p-5">
    <h4 className="font-serif text-[16px] font-semibold text-[#23312E] m-0 mb-3">
      Words on this page
    </h4>

    <dl className="m-0">
      {entries.map((entry, i) => (
        <div key={i} className={i > 0 ? "mt-3" : ""}>
          <dt className="font-semibold text-[13.5px] text-[#23312E]">
            {entry.term}
          </dt>
          <dd className="m-0 mt-0.5 text-[13px] text-[#5C6B66]">
            {entry.definition}
          </dd>
        </div>
      ))}
    </dl>
  </div>
);

export default Glossary;